import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import MenuUI from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { ROUTES } from "../../utils/RouteConstants";
import MenuList from "./MenuList";
import { MenuHeaderStyle } from "./MenuStyles";
import useUserData from "../../hooks/useUserData";
import {
  MenuDiv,
  MenuToolbar,
  StyledTypography,
  StyledButton,
  StyledMenuIcon,
} from "./MenuStyles";
import ThemeToggleSwitch from "../../shared/ThemeToggleSwitch";

export default function Menu({ children }) {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const user = useUserData();

  const isMounted = useRef(true);

  let history = useHistory();
  let location = useLocation();

  //clean up function
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [side]: open });
  };

  return (
    <div>
      {localStorage.token ? (
        <MenuDiv>
          <AppBar position="sticky">
            <MenuToolbar>
              <StyledButton onClick={toggleDrawer("left", true)}>
                <StyledMenuIcon />
              </StyledButton>
              <Drawer
                open={state.left}
                onClose={toggleDrawer("left", false)}
                children={
                  <MenuList
                    toggleDrawer={toggleDrawer}
                    side={"left"}
                    user={user}
                  />
                }
              ></Drawer>
              <StyledTypography variant="h6">
                <MenuHeaderStyle>{process.env.REACT_APP_ORG_NAME}</MenuHeaderStyle>
              </StyledTypography>
              <StyledButton onClick={handleMenu} color="inherit">
                {user && "Salaam, " + user.name}
              </StyledButton>
              <ThemeToggleSwitch />
              <MenuUI
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={() => {
                    history.push(ROUTES.LOGIN, { last: location.pathname });
                  }}
                >
                  Log Out
                </MenuItem>
              </MenuUI>
            </MenuToolbar>
          </AppBar>
          {children}
        </MenuDiv>
      ) : (
        //if they are not logged in they are booted out to log in page
        history.push(ROUTES.LOGIN)
      )}
    </div>
  );
}
